import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SpinnerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
